import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { RfisPage } from '@/features/design/rfis-page';

const searchSchema = z.object({
  rfi: z.string().optional().catch(undefined),
  view: z.enum(['list', 'ageing']).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/design/rfis')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <RfisPage projectId={projectId} rfiId={search.rfi} view={search.view ?? 'list'} />;
}
